const searchParamsEnum = {
    PAGE:"page",
    SEARCH:"search"
}

export default searchParamsEnum;